
import {defineComponent} from "vue";
import {FormMixin} from "@/components/base/FormMixin";
import GenericFormWrapper from "@/components/base/GenericFormWrapper.vue";
import BaseModal from "@/components/UI/Bootstrap/Modal/BaseModal.vue";
import BaseModalButton from "@/components/UI/Bootstrap/Modal/BaseModalButton.vue";
import LabelsInput from "@/components/UI/Bootstrap/LabelsInput.vue";
import {TokenExchangeRequestRestDto} from "@/api/pharma-auth-admin/models";
import {TokenExchangeRequestRestDtoModel} from "@/models/api/pharma-auth-admin/TokenExchangeRequestRestDtoModel";
import {AuthService} from "@/services/business/AuthService";
import {AuthContext} from "@/context/AuthContext";

const MIN_CUSTOMER_CODES = 1;
const MAX_CUSTOMER_CODES = 5;
const MAX_CUSTOMER_CODE_LENGTH = 50;

export default defineComponent({
  name: "UserModeDialog",
  mixins: [FormMixin],
  components: {GenericFormWrapper, BaseModal, BaseModalButton, LabelsInput},
  props: {
    modalId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      request: TokenExchangeRequestRestDtoModel.createWithDefaults() as TokenExchangeRequestRestDto,
    };
  },
  mounted() {
    this.reloadContent();
  },
  methods: {
    async doReload(): Promise<void> {
      const request = TokenExchangeRequestRestDtoModel.createWithDefaults();
      request.customer_codes = AuthService.getInstance().getLastUserModeCustomerCodes();

      this.request = request;
    },
    async submitData(): Promise<void> {
      // startUserMode reloads the whole SPA on success, so nothing has to happen after the submit
      await this.performGenericSubmit(this.doSubmit, this.doNothing);
    },
    async doSubmit(): Promise<void> {
      await AuthService.getInstance().startUserMode(this.request.customer_codes);
    },
    hasAuthorization(): boolean {
      return AuthContext.isDpUser(true) && !AuthContext.isUserMode();
    },
    validateCustomerCodes(customerCodes: string[] | null | undefined): boolean | string {
      const codes: string[] = customerCodes ?? [];
      const isValid: boolean = codes.length >= MIN_CUSTOMER_CODES
        && codes.length <= MAX_CUSTOMER_CODES
        && codes.every((code: string) => code.trim().length > 0 && code.trim().length <= MAX_CUSTOMER_CODE_LENGTH);

      return isValid || (this.$t('userModeCustomerCodesInvalid') as string);
    },
  },
});
